export default __webpack_public_path__ + "static/media/simpleBullet.5a871e2a.svg";